<template>
  <div class="floating-input-label">
    <input
      class="floating-input-label__input"
      type="password"
      :id="_uid"
      :required="mandatory"
      :pattern="pattern"
      :placeholder="label"
      maxlength="255"
      v-model="currentValue"
      @keyup="handleChange"
    >
    <label class="floating-input-label__label" :for="_uid">{{ label }}</label>
  </div>
</template>

<script>
export default {
  data: () => ({
    currentValue: '',
  }),
  props: {
    label: String,
    mandatory: {
      type: Boolean,
      default: false,
    },
    pattern: String,
    value: String,
  },
  methods: {
    handleChange() {
      this.$emit('input', this.currentValue);
    },
  },
  created() {
    this.currentValue = this.value ?? '';
  },
};
</script>
